import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <button onClick={handleLogout} style={styles.button}>
      Logout →
    </button>
  );
}

const styles = {
  button: {
    position: 'fixed',
    top: '20px',
    right: '20px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    padding: '8px 14px',
    color: 'var(--text-muted)',
    fontFamily: 'var(--font-mono)',
    fontSize: '12px',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    zIndex: 100,
  },
};

